import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Spravy.scss";

// actions
import * as spravyActions from "../../actions/spravyActions";

// prop types
import spravyPropTypes from "../../propTypes/spravyPropTypes";

// core web components
import Grid from '../../coraWebComponents/dataGrid/DataGrid';
import flags from "../../coraWebComponents/dataGrid/flags";
import Tab from "../../coraWebComponents/Tab";
import Tabs from "../../coraWebComponents/TabsWrapper";

// components
import Detail from "./Detail";


const Spravy = (props) => {
  const { isLoading, total, listSprava, sprava } = props;

  const [selected, setSelected] = useState([]);
  const filter = useRef({ filters: [] });
  const sort = useRef([]);
  const page = useRef({ skip: 0, take: 10 });
  const setFilter = (newFilter) => { filter.current = newFilter };
  const setSort = (newSort) => { sort.current = newSort };
  const setPage = (newPage) => { page.current = newPage };

  const [data, setData] = useState(listSprava);


  useEffect(() => {
    setData(listSprava);
  }, [listSprava]);

  const cellRender = useCallback((tdElement, cellProps) => {
    const { dataItem } = cellProps;

    var tdProps = { ...tdElement.props };

    tdProps.className += (dataItem.L_PRECITANE ? "" : "neprecitane");

    return React.cloneElement(tdElement, { ...tdProps }, tdElement.props.children);
  }, []);

  // GRID PROPS
  const genSchema = () => {
    return [
      {
        field: "ZP_SPRAVY_D_PUB",
        title: "Dátum publikácie",
        filter: "date",
        format: "{0:dd.MM.yyyy}",
        width: "200px",
      },
      {
        field: "ZP_SPRAVY_TEXT",
        title: "Text",
        width: "auto",
        filter: "text",
      },
      {
        field: "ADRESAT",
        title: "Adresát",
        width: "200px",
        filter: "text",
      },
    ];
  }

  const schema = useMemo(() => genSchema(), []);

  const fixedFilter = useMemo(() => ({ filters: [{ field: "ZRUS", operator: "eq", value: false }] }), []);
  const noop = useCallback(() => { }, []);
  const emptyArray = useMemo(() => [], []);

  const handleChange = useCallback((filter, sort, page) => {
    setFilter(filter);
    setSort(sort);
    setPage(page);
  }, []);

  const handleOnGetList = useCallback(async () => {
    const {
      customFilters,
      getListSpravaCurrentUser,
      getCountNeprecitaneSpravy,
    } = props;

    await getListSpravaCurrentUser(
      filter.current,
      sort.current,
      page.current,
      customFilters
    );
    await getCountNeprecitaneSpravy(-1);
  }, [props.customFilters, props.getListSpravaCurrentUser, props.getCountNeprecitaneSpravy]);

  const handleOnGet = useCallback(async (I_ZP_SPRAVY_UZ) => {
    const {
      changeSprava,
      updateSprava,
      getCountNeprecitaneSpravy,
      isUserAdmin,
    } = props;

    const spravaUZ = listSprava.find(
      (s) => s.I_ZP_SPRAVY_UZ === I_ZP_SPRAVY_UZ
    );

    if (spravaUZ) {
      if (!spravaUZ.L_PRECITANE) {
        const updateMsg = !isUserAdmin || spravaUZ.I_ORGAN === null;

        if (updateMsg) {
          spravaUZ.L_PRECITANE = true;
          await updateSprava({
            ...spravaUZ,
            ZP_SPRAVY_D_PUB: spravaUZ.ZP_SPRAVY_D_PUB,
          });

          await getCountNeprecitaneSpravy(-1);
        }
      }
      changeSprava(spravaUZ);
    }
  }, [props.changeSprava, props.updateSprava, props.getCountNeprecitaneSpravy, props.isUserAdmin, listSprava]);

  const handleDelete = useCallback(async (id) => {
    const {
      updateSprava,
    } = props;

    const spravaUZ = listSprava.find(
      (s) => s.I_ZP_SPRAVY_UZ === id
    );

    await updateSprava({
      ...spravaUZ,
      ZRUS: true
    });
  }, [props.updateSprava, listSprava])

  const handleGridSelect = useCallback((selected) => {
    setSelected(selected);
  }, []);

  return (
    <div className="row m-0 component">
      <div className="col p-0">
        <Tabs>
          <Tab title="Zoznam">
            <Grid
              total={total}
              data={data}
              isLoading={isLoading}
              onDelete={handleDelete}
              onChange={handleChange}
              onGet={handleOnGet}
              onGetList={handleOnGetList}
              selected={selected}
              onSelect={handleGridSelect}
              primaryField={"I_ZP_SPRAVY_UZ"}
              schema={schema}
              cellRender={cellRender}
              fixedFilter={fixedFilter}
              initSort={emptyArray}
              onChangeField={noop}
              onCancel={noop}
              updateSort={noop}
              filter={filter.current}
              sort={sort.current}
              page={page.current}
              hidden={flags.ADD | flags.COPY | flags.CANCEL | flags.PRINT | flags.RESET |
                flags.EDIT | flags.COLUMN_MENU | flags.COLUMN_SELECTED | flags.EDITALL | flags.GRID_CELL_EDIT | flags.USER_FILTER}
              hiddenBack
            />
          </Tab>
          <Tab title="Detail">
            <Detail
              onSubmit={handleOnGetList}
              onGet={handleOnGet}
              allData={data}
              data={sprava}
              isLoading={isLoading}
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    // list sprava
    customFilters: state.listSprava.customFilters,
    isLoading: state.listSprava.isLoading,
    listSprava: state.listSprava.data,
    total: state.listSprava.total,

    // odberetal
    isUserAdmin: state.user.data.Uzivatel.L_ADMIN,
    sprava: state.sprava.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCountNeprecitaneSpravy: async (I_ORGAN) => await dispatch(spravyActions.getCountNeprecitaneSpravy(I_ORGAN)),
  getListSpravaCurrentUser: async (
    gridFilter,
    gridSort,
    gridPage,
    customFilters
  ) =>
    await dispatch(
      spravyActions.getListSpravaCurrentUser({
        gridFilter,
        gridSort,
        gridPage,
        customFilters,
      })
    ),
  changeSprava: (data) => dispatch(spravyActions.changeSprava(data)),
  updateSprava: (data) => dispatch(spravyActions.updateSprava(data)),
});

Spravy.propTypes = {
  customFilters: PropTypes.arrayOf(PropTypes.object),
  changeSprava: PropTypes.func,
  isLoading: PropTypes.bool,
  isUserAdmin: PropTypes.bool,
  listSprava: PropTypes.arrayOf(spravyPropTypes.sprava),
  getCountNeprecitaneSpravy: PropTypes.func,
  getListSpravaCurrentUser: PropTypes.func,
  getSprava: PropTypes.func,
  total: PropTypes.number,
  updateSprava: PropTypes.func,
  sprava: spravyPropTypes.sprava,
};

export default connect(mapStateToProps, mapDispatchToProps)(Spravy);
